import cl from './Product.module.css';
import React, { useState, useContext } from 'react';
import { NavLink } from 'react-router-dom';

const Product = (props) => {
  const [style, setStyle] = useState(cl.add_to_cart);
  const [style2, setStyle2] = useState(cl.product);
  const [isAdded, setIsAdded] = useState(false);

  let hoveron = () => {
    setStyle(cl.add_to_cart_active);
    setStyle2(cl.product_hover);
  };
  let hoveroff = () => {
    setStyle(cl.add_to_cart);
    setStyle2(cl.product);
  };
  let onClick = () => {
    props.onAdd(props);
    setIsAdded(!isAdded);
  };

  
  let newPrice = ((props.oldPrice * (100 - props.discount)) / 100).toFixed(2);
  const image = props.images ? props.images[0] : null;

  return (
    <section className={style2}>
      <div className={cl.product_image_inner}>
        <div className={cl.product_image_container}>
          <NavLink to={props.path}>
            <img className={cl.image} src={image} onMouseEnter={hoveron} onMouseOut={hoveroff}/>
          </NavLink>
        </div>
        <div className={cl.discount}>-{props.discount}%</div>
        <div className={style} onMouseEnter={hoveron} onMouseOut={hoveroff} onClick={onClick}>
          {!isAdded ? <svg viewBox="0 0 20 19.84" xmlns="http://www.w3.org/2000/svg"><path d="M15.8,9.65A1.88,1.88,0,0,0,14.69,9l.67-.86a.45.45,0,0,0-.08-.64.46.46,0,0,0-.64.08L13.58,9H6.34L5.17,7.64a.46.46,0,0,0-.64,0,.45.45,0,0,0,0,.64L5.18,9A1.91,1.91,0,0,0,4,9.88a2,2,0,0,0-.26,1.47l.72,4.37a1.92,1.92,0,0,0,1.82,1.69H13.7a1.89,1.89,0,0,0,1.79-1.66l.73-4.38a2.36,2.36,0,0,0,0-.28A1.94,1.94,0,0,0,15.8,9.65Zm-.48,1.55-.73,4.42a1,1,0,0,1-.92.88H6.35a1,1,0,0,1-.94-.9l-.73-4.43a1,1,0,0,1,.13-.81,1.1,1.1,0,0,1,.67-.48l.11,0h8.78a1.07,1.07,0,0,1,.73.38,1.05,1.05,0,0,1,.25.78A.74.74,0,0,1,15.32,11.2Z"/><path d="M7.52,11.52a.47.47,0,0,0-.46.46v2.63a.46.46,0,0,0,.92,0V12A.47.47,0,0,0,7.52,11.52Z"/><path d="M9.93,11.52a.46.46,0,0,0-.46.46v2.63a.46.46,0,0,0,.91,0V12A.46.46,0,0,0,9.93,11.52Z"/><path d="M12.4,11.52A.46.46,0,0,0,12,12v2.63a.46.46,0,0,0,.91,0V12A.46.46,0,0,0,12.4,11.52Z"/><path d="M9.59,8.57a.46.46,0,0,0,.68,0l2.81-3.11a.45.45,0,0,0,0-.64.46.46,0,0,0-.65,0L10.41,7V2.89a.46.46,0,1,0-.91,0V7.1l-2-2.25a.46.46,0,0,0-.68.61Z"/></svg> : <svg fill="none" height="24" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><polyline points="20 6 9 17 4 12"/></svg>}
        </div>
      </div>
      <div className={cl.profile}>
        <div className={cl.info}>
          <p>{props.name}</p>
          <div className={cl.price}>
            <p className={cl.old}>
              {props.currency}
              {props.oldPrice}
            </p>
            <p className={cl.new}>
              {props.currency}
              {newPrice}
            </p>
          </div>
        </div>
      </div>
      <div></div>
    </section>
  );
};

export default Product;
